import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { SpinnerService } from './spinner.service';

@Component({
  selector: 'ideals-spinner',
  styleUrl: './spinner.component.scss',
  templateUrl: './spinner.component.html',
})
export class SpinnerComponent {
  readonly #spinnerService = inject(SpinnerService);

  protected readonly showSpinner = toSignal(this.#spinnerService.active$, { initialValue: false });
}
